const TRANSLATION = {
  buyModal: {
    afterFree: 'پس از آزمایش رایگان شما',
    btn: 'آن را رایگان امتحان کنید',
    freeTrial: 'آزمایشی رایگان 3 روزه',
    monthLabel: 'ماه',
    selectLabel: 'یک طرح را انتخاب کنید',
    title: 'طرح اشتراک',
    yearLabel: 'سال',
  },
  contact: {
    block1:
      'برای سفارشی سازی، سؤالات یا پیشنهادات، لطفاً با ما در contact@noam.tools تماس بگیرید. ما به سرعت پاسخ خواهیم داد.',
    block2: 'با رتبه بندی ما در فروشگاه برنامه های افزودنی Google در ★★★★★ از ما حمایت کنید.',
    block3: 'با اشتراک گذاری این افزونه به دیگران کمک کنید:',
    title: 'تماس با ما',
  },
  help: {
    AquickOverviewOfNoam: 'مروری سریع بر نوام',
    ChatPDF: 'چت پی دی اف',
    ChatPDF2: 'چت پی دی اف',
    FavoritesManagement: 'مدیریت علاقه مندی ها',
    Fixedplugin: 'پلاگین ثابت',
    Focusing: 'تمرکز کردن',
    Free: 'رایگان',
    FreeTrialBenefits: 'مزایای آزمایشی رایگان',
    GoWithWikipedia: 'با ویکی پدیا بروید',
    GoWithYouTube: 'با YouTube بروید',
    HoverTranslation: 'ترجمه شناور',
    Howtouse: 'نحوه استفاده',
    ImageTranslation: 'ترجمه تصویر',
    InstantTranslation: 'ترجمه فوری',
    Membership: 'عضویت',
    NoamHelp: 'Noam به شما در ترجمه و خلاصه کردن کمک می کند',
    PDFparallelTranslation: 'ترجمه موازی PDF',
    ParallelTranslation: 'ترجمه موازی',
    SkipAllSteps: 'رد شدن از همه مراحل',
    Summary: 'خلاصه',
    Translation: 'ترجمه',
    TryItForFree: 'آن را به صورت رایگان امتحان کنید',
    Video: 'ویدئو',
    VideoSummary: 'خلاصه ویدیو',
    VideoTranslation: 'ترجمه ویدیویی',
    WebSummary: 'خلاصه وب',
    WordSelectionTranslation: 'ترجمه انتخاب واژه',
    benefits: 'ما مزایایی در انتظار شما داریم!',
    dayFree: 'آزمایشی رایگان 3 روزه',
    done: 'انجام شد',
    next: 'بعدی',
    pin: 'برای دسترسی آسان‌تر نوام را پین کنید',
    planIsNotExist: 'طرح در دسترس نیست',
    startWiki: 'بیایید با ویکی مدیا شروع کنیم!',
    startYoutube: 'بیایید با یوتیوب شروع کنیم!',
    try: 'آن را امتحان کنید',
    tryNow: 'اکنون آن را امتحان کنید!',
  },
  home: {
    PDFTranslate: {
      desc: 'ترجمه دو زبانه + چت PDF',
      sub1: {
        desc: 'خواندن دو زبانه به شما امکان می دهد متن اصلی و ترجمه را در کنار هم مقایسه کنید و کارایی خواندن را بهبود ببخشید.',
        title: 'خواندن دو زبانه',
      },
      sub2: {
        desc: 'هوش مصنوعی تجزیه و تحلیل و خلاصه می کند و می تواند بر اساس محتوای PDF به سوالات شما پاسخ دهد.',
        title: 'چت پی دی اف',
      },
      sub3: {
        desc: 'ترجمه PDF مبتنی بر هوش مصنوعی برای دقت و کارایی بیشتر.',
        title: 'دقت و کارایی',
      },
      title: 'ترجمه PDF',
    },
    aiAssistant: {
      desc: 'ترجمه وب را هوشمندتر و راحت تر کنید',
      panel1: {
        desc: 'ترجمه های دوزبانه دو زبانه به شما کمک می کند متن اصلی را با ترجمه مقایسه کنید تا بتوانید بهتر درک کنید و کارایی خواندن خود را بهبود بخشید.',
        title: 'ترجمه دو زبانه',
      },
      panel2: {
        left: {
          desc: 'هنگام مرور یک صفحه وب، ماوس را روی محتوایی که برای ترجمه نیاز دارید نگه دارید تا ترجمه را ببینید.',
          title: 'ترجمه شناور',
        },
        right: {
          desc: 'هنگام مرور یک صفحه وب، متن مورد نظر برای ترجمه را انتخاب کنید تا ترجمه را ببینید.',
          title: 'ترجمه انتخاب متن',
        },
      },
      panel3: {
        one: {
          desc: 'صفحات وب و محتوای ویدیویی را در هر زمان و هر مکان ترجمه و خلاصه کنید تا تجربه ای روان تر داشته باشید!',
          title: 'اشاره کنید و کلیک کنید',
        },
        three: {
          desc: 'مدل زبان بزرگ مبتنی بر هوش مصنوعی دقت و ثبات ترجمه را برای یک تجربه خواندن پیشرفته تضمین می کند.',
          title: 'AI-Driven',
        },
        two: {
          desc: 'پوشش کامل چند زبانه، خواندن دو زبانه بدون مانع، ترجمه با یک کلیک - تفاوت را تجربه کنید!',
          title: 'جامع تر و راحت تر',
        },
      },
      panel4: {
        tab1: {
          desc: 'متخصص کارآمدی شما - با استفاده از ChatGPT، Noam محتوای ویدیوی YouTube را ترجمه و خلاصه می کند تا در وقت شما صرفه جویی کند!',
          key: 'ویدئو',
          title: 'ترجمه و خلاصه ویدیو',
        },
        tab2: {
          desc: 'برای ترجمه تصاویر هنگام مرور وب کلیک کنید.',
          key: 'تصویر',
          title: 'ترجمه تصویر',
        },
        tab3: {
          desc: 'فوراً اطلاعات کلیدی را از صفحات وب استخراج می کند و خلاصه ای را ارائه می دهد و کارایی خواندن شما را افزایش می دهد.',
          key: 'وب',
          title: 'ترجمه وب و خلاصه',
        },
        tag1: 'ساده',
        tag2: 'کارآمد',
        tag3: 'آسان برای درک',
      },
      title: 'دستیار هوش مصنوعی',
    },
    getStart: 'شروع کنید',
    getStartedForFree: 'به صورت رایگان شروع کنید',
    howItWork: {
      desc: 'Noam مدل‌های هوش مصنوعی را ادغام می‌کند تا تجربه‌ای هوشمند را برای ترجمه و خلاصه‌سازی صفحات وب بین زبانی، ترجمه PDF و تصویر، ترجمه ویدیویی و خلاصه‌سازی به کاربران ارائه دهد.',
      title: 'چگونه کار می کند',
    },
    lastBlock: { desc: 'ترجمه بهتر هوش مصنوعی برای تجربه خواندن روانتر' },
    top: {
      desc: 'Noam یک افزونه رایگان مرورگر هوش مصنوعی است که به شما کمک می کند صفحات وب، ویدیوها و محتوای PDF را ترجمه و خلاصه کنید.\\n به Noam بپیوندید و جادو را تجربه کنید!',
      title1: 'یک جادو',
      title2: 'یک کلیک',
    },
    userReviews: { desc: 'نظرات پنج ستاره در فروشگاه وب کروم', title: 'نظرات کاربران' },
  },
  installTips: {
    btn: 'اکنون آن را امتحان کنید',
    text: 'برای باز کردن قفل ویژگی های بیشتر، "Plugin مرورگر نوام" را نصب کنید! ارجاع متقابل وب،\\n خلاصه‌سازی ویدیوی وب، و موارد دیگر!',
  },
  locale: {
    af: 'آفریقایی',
    am: 'آمهری',
    ar: 'عربی',
    as: 'آسامی',
    auto: 'تشخیص خودکار',
    az: 'آذربایجانی',
    ba: 'باشقیر',
    bg: 'بلغاری',
    bn: 'بنگلا',
    bo: 'تبتی',
    bs: 'بوسنیایی',
    ca: 'کاتالان',
    cs: 'چک',
    cy: 'ولزی',
    da: 'دانمارکی',
    de: 'آلمانی',
    dsb: 'زبان سوربی پایین',
    dv: 'دیوه ای',
    el: 'یونانی',
    en: 'انگلیسی',
    es: 'اسپانیایی',
    et: 'استونیایی',
    eu: 'باسکی',
    fa: 'فارسی',
    fi: 'فنلاندی',
    fil: 'فیلیپینی',
    fj: 'فیجیایی',
    fr: 'فرانسوی',
    frCA: 'فرانسوی (کانادا)',
    ga: 'ایرلندی',
    gl: 'گالیسیایی',
    gom: 'کنکانی',
    gu: 'گجراتی',
    ha: 'هاوسا',
    he: 'عبری',
    hi: 'هندی',
    hr: 'کروات',
    hsb: 'زبان سوربی بالایی',
    ht: 'کریول هائیتی',
    hu: 'مجارستانی',
    hy: 'ارمنی',
    id: 'اندونزیایی',
    ig: 'ایگبو',
    ikt: 'اینوینناکتون',
    is: 'ایسلندی',
    it: 'ایتالیایی',
    iu: 'اینوکتیتوت',
    iuLatn: 'اینوکتیتوت (لاتین)',
    ja: 'ژاپنی',
    ka: 'گرجی',
    kk: 'قزاقستان',
    km: 'خمر',
    kmr: 'کردی (شمالی)',
    kn: 'کانادا',
    ko: 'کره ای',
    ku: 'کردی (مرکزی)',
    ky: 'قرقیزستان',
    ln: 'لینگالا',
    lo: 'لائوس',
    lt: 'لیتوانیایی',
    lug: 'گاندا',
    lv: 'لتونی',
    lzh: 'چینی (ادبی)',
    mai: 'مایتیلی',
    mg: 'مالاگاسی',
    mi: 'مائوری',
    mk: 'مقدونی',
    ml: 'مالایایی',
    mnCyrl: 'مغولی (سیریلیک)',
    mnMong: 'مغولی (سنتی)',
    mr: 'مراتی',
    ms: 'مالایی',
    mt: 'مالتی',
    mww: 'همونگ داو',
    my: 'میانمار (برمه)',
    nb: 'نروژی',
    ne: 'نپالی',
    nl: 'هلندی',
    noSearchLang: 'زبان پشتیبانی نمی شود',
    nso: 'سسوتو سا لبوآ',
    nya: 'نیانجا',
    or: 'اودیا',
    otq: 'کوئرتارو اوتومی',
    pa: 'پنجابی',
    pl: 'لهستانی',
    placeholder: 'جستجو کنید',
    prs: 'دری',
    ps: 'پشتو',
    pt: 'پرتغالی (برزیل)',
    ptPT: 'پرتغالی (پرتغال)',
    ro: 'رومانیایی',
    ru: 'روسی',
    run: 'رودی',
    rw: 'کینیارواندا',
    sd: 'سندی',
    si: 'سینهالی',
    sk: 'اسلواکی',
    sl: 'اسلوونیایی',
    sm: 'ساموآ',
    sn: 'شونا',
    so: 'سومالی',
    sq: 'آلبانیایی',
    srCyrl: 'صربی (سیریلیک)',
    srLatn: 'صربی (لاتین)',
    st: 'سسوتو',
    sv: 'سوئدی',
    sw: 'سواحیلی',
    ta: 'تامیل',
    te: 'تلوگو',
    th: 'تایلندی',
    ti: 'تیگرینیا',
    tk: 'ترکمن',
    tlhLatn: 'کلینگون (لاتین)',
    tlhPiqd: 'کلینگون (pIqaD)',
    tn: 'ستسوانا',
    to: 'تونگان',
    tr: 'ترکی',
    tt: 'تاتاری',
    ty: 'تاهیتی',
    ug: 'اویغور',
    uk: 'اوکراینی',
    ur: 'اردو',
    uz: 'ازبکی (لاتین)',
    vi: 'ویتنامی',
    xh: 'خوسا',
    yo: 'یوروبا',
    yua: 'یوکاتک مایا',
    yue: 'کانتونی (سنتی)',
    zh: 'چینی',
    zhHans: 'چینی ساده شده',
    zhHant: 'سنتی چینی',
    zu: 'زولو',
  },
  login: {
    and: 'و',
    btn: 'با گوگل وارد شوید',
    btn1: 'اکنون وارد شوید',
    desc: 'برای باز کردن تجربه های بیشتر وارد شوید',
    policy: 'سیاست حفظ حریم خصوصی',
    terms: 'شرایط استفاده',
    tips: 'با ثبت نام، موافقم',
    title: 'به نوام خوش آمدید',
  },
  pageFooter: {
    follow: { facebook: 'فیس بوک', title: 'دنبال کنید', twitter: 'توییتر' },
    legal: { policy: 'سیاست حفظ حریم خصوصی', terms: 'شرایط خدمات', title: 'قانونی' },
    product: {
      image: 'ترجمه تصویر',
      pdf: 'ترجمه PDF',
      title: 'محصولات',
      video: 'ترجمه و خلاصه ویدیو',
      web: 'ترجمه و خلاصه وب',
    },
    resources: { title: 'منابع' },
  },
  pageHeader: {
    contact: 'تماس بگیرید',
    help: 'کمک کنید',
    logout: 'از سیستم خارج شوید',
    logoutSucc: 'از سیستم خارج شد.',
    pricing: 'قیمت گذاری',
    settings: 'تنظیمات',
    signUp: 'وارد شوید',
  },
  pdf: {
    autoDetect: 'تشخیص خودکار',
    cancelBtn: 'لغو کنید',
    cancelUpload: 'لغو کنید',
    chatPdf: {
      Search: 'جستجو کنید',
      cancel: 'لغو کنید',
      chatTitle: 'به نوام خوش آمدید! در اینجا خلاصه ای از PDF شما آمده است:',
      clear: 'پاک کردن',
      clearContent: 'این یک مکالمه جدید را آغاز می کند. مکالمه فعلی ذخیره نخواهد شد. مطمئنی؟',
      clearDialogTitle: 'لطفا تایید کنید',
      clearSucc: 'پاک شد',
      copy: 'کپی کنید',
      copySucc: 'کپی شده است',
      delete: 'حذف کنید',
      deleteCancel: 'لغو کنید',
      deleteContent: 'این PDF پس از حذف قابل بازیابی نیست. مطمئنی؟',
      deleteOk: 'حذف کنید',
      deleteSuccess: 'حذف شد',
      deleteTitle: 'حذف را تایید کنید',
      expand: 'فرو ریختن',
      historyTitle: 'تاریخچه',
      listError:
        'فهرست خواندن بارگیری نشد. لطفاً بعداً دوباره امتحان کنید یا با پشتیبانی تماس بگیرید.',
      loading: 'در حال بارگیری...',
      noDataDesc: 'هنوز سابقه ندارد.',
      noMore: 'دیگر محتوایی وجود ندارد.',
      placeholder: 'هر چیزی در مورد این PDF بپرسید',
      summaryTitle: 'ممکن است به این سوالات علاقه مند باشید:',
    },
    collectionEmpty: 'مجموعه شما خالی است',
    collectionTab: 'یادداشت ها',
    dataLoading: 'در حال بارگیری...',
    dialogContent: 'آیا مطمئنید که می خواهید این را حذف کنید؟',
    dialogTitle: 'لطفا تایید کنید',
    download: {
      both: 'دو زبانه',
      btn: 'ذخیره کنید',
      cancel: 'با بستن این پنجره، دانلود PDF لغو می شود. آیا مطمئن هستید که می خواهید لغو کنید؟',
      desc: 'ذخیره در دستگاه: ترجمه ها را به صورت تصویر دانلود می کند. ذخیره و چاپ: ترجمه ها را در قالب اصلی، با پشتیبانی از کپی دانلود می کند.',
      download: 'دانلود کنید',
      downloadMsg1: 'پیشرفت ترجمه PDF:',
      downloadMsg2: 'زمان باقیمانده تخمینی:',
      downloadSucc: 'PDF آماده است! برای ذخیره کلیک کنید.',
      downloadTip: 'در حال دانلود PDF. برای جلوگیری از خطاهای دانلود، این پنجره را نبندید.',
      error: 'ذخیره نشد. به جای آن چاپ را امتحان کنید.',
      fileName: 'نام فایل:',
      fileType: 'نوع فایل:',
      loading: 'در حال ذخیره...',
      loading2: 'در حال بارگیری...',
      minute: 'دقیقه...',
      msg1: 'برخی از ترجمه های این سند طولانی تر از متن اصلی هستند و ممکن است در فایل دانلود شده همپوشانی داشته باشند. توصیه می کنیم در صفحه وب مطالعه کنید.',
      msg2: '1. ترجمه هنوز کامل نشده است. لطفا پس از پایان ترجمه دانلود کنید.',
      msg3: '2. برخی از ترجمه ها بیش از حد طولانی هستند. برای جلوگیری از همپوشانی متن، در صفحه وب بخوانید.',
      msg4: 'کارهای ترجمه در حال انجام است. لطفاً پس از تکمیل آنها دوباره امتحان کنید.',
      progress: 'ترجمه PDF. پیشرفت: {{پیشرفت}}، زمان تخمینی باقی مانده: {{دقیقه}} دقیقه...',
      save: 'ذخیره در دستگاه',
      savePrint: 'ذخیره و چاپ',
      success: 'دانلود شد',
      trans: 'فقط ترجمه',
      transContinue: 'ادامه ترجمه',
    },
    downloadBtn: 'دانلود کنید',
    dragTipModal: {
      black: 'فضا',
      leftKey: 'دکمه سمت چپ',
      ok: 'متوجه شدم',
      press: 'را فشار دهید',
      tips: 'برای کشیدن و مشاهده',
    },
    entry: 'فایل های PDF',
    fileErrMsg: 'خواندن فایل انجام نشد. لطفاً بعداً دوباره امتحان کنید یا با پشتیبانی تماس بگیرید.',
    fileMsg: 'اندازه فایل فعلی:',
    fileMsg2: 'لطفا یک فایل کوچکتر از 300 مگابایت آپلود کنید.',
    freeBannerBtn: 'ارتقا دهید',
    freeBannerTips: 'به محدودیت ترجمه رایگان PDF رسیده است',
    guide: {
      placeholder: 'لینک پی دی اف را اینجا قرار دهید',
      start: 'شروع به ترجمه کنید',
      text1: 'خواندن دو زبانه',
      text2:
        'دوزبانه بخوانید تا متن اصلی و ترجمه را در کنار هم مقایسه کنید و کارایی خود را بهبود ببخشید.',
      text3: 'با PDF خود چت کنید',
      text4:
        'تجزیه و تحلیل و خلاصه سازی مبتنی بر هوش مصنوعی. درباره PDF خود سؤال بپرسید و پاسخ های فوری دریافت کنید.',
      text5: 'دقیق و کارآمد',
      text6: 'ترجمه PDF مبتنی بر هوش مصنوعی برای دقت و کارایی بیشتر.',
      title1: 'ترجمه دو زبانه',
      title2: 'با PDF خود چت کنید',
      toast: 'لطفاً یک پیوند PDF آنلاین معتبر که به .pdf ختم می شود وارد کنید',
    },
    hasTransTask: 'یک کار ترجمه در حال انجام است. لطفا صبر کنید.',
    hoverTrans: 'ماوس برای ترجمه پاراگراف ها',
    initial: 'PDF را ترجمه کنید',
    installText: 'راه حل یک مرحله ای شما برای ترجمه های روزمره.',
    installText2: 'لطفا ابتدا افزونه را نصب کنید',
    installTips: 'افزونه را برای ترجمه‌های PDF بیشتر و ترجمه‌های وب‌سایت روان‌تر نصب کنید:',
    kw: 'اصلی',
    link: 'پیوند',
    listError:
      'فایل های PDF بارگیری نشد. لطفاً بعداً دوباره امتحان کنید یا با پشتیبانی تماس بگیرید.',
    memoTotalCount: 'کل 1 مورد',
    new: 'فایل جدید',
    noId: 'شناسه فایل پیدا نشد',
    notPdf: 'فقط فایل های PDF',
    okBtn: 'حذف کنید',
    okBtn2: 'متوجه شدم',
    original: 'اصلی',
    parallel: 'موازی',
    parseErrDialogContent:
      'این پیوند PDF را نمی توان مستقیماً ترجمه کرد. لطفا پی دی اف را دانلود و برای ترجمه بارگذاری کنید.',
    parseErrTips: 'تجزیه فایل انجام نشد',
    parseFileToast:
      'تجزیه فایل انجام نشد. لطفاً بعداً دوباره امتحان کنید یا با پشتیبانی تماس بگیرید.',
    pdfLoading: 'تجزیه...',
    searchPlaceholder: 'جستجو کنید',
    selectTrans: 'متن برای ترجمه را انتخاب کنید',
    shareBtn: 'به اشتراک بگذارید',
    shareBtnText1: 'ایجاد لینک اشتراک گذاری',
    shareBtnText2: 'محتوای مشترک را به روز کنید',
    shareModal: {
      cancel: 'لغو کنید',
      copy: 'کپی کنید',
      copySucc: 'پیوند کپی شد',
      custom: 'سفارشی کردن:',
      errMsg:
        'محتوای انتخاب شده هنوز به طور کامل ترجمه نشده است. لطفا قبل از اشتراک گذاری ترجمه کنید.',
      gen: 'به اشتراک بگذارید',
      modify: 'ویرایش کنید',
      notSupport: 'این زبان در حال حاضر پشتیبانی نمی شود.',
      page: 'صفحات',
      pageNuErr: 'لطفاً یک شماره صفحه معتبر وارد کنید.',
      range: 'محدوده:',
      remain: 'باقی مانده است',
      remain1: 'کل زمان تخمینی:',
      search: 'جستجو کنید',
      settings: 'تنظیمات اشتراک گذاری:',
      shareSetting: 'تنظیمات را به اشتراک بگذارید',
      shareText: 'به اشتراک بگذارید',
      shareTips: 'پیوند PDF ترجمه شده را با دوستان خود به اشتراک بگذارید:',
      sourceLang: 'از:',
      target: 'به:',
      text1: 'تنظیمات را به اشتراک بگذارید',
      text2: 'ایجاد لینک اشتراک گذاری',
      totalPage: 'کل 1 صفحه',
      trans: 'ترجمه کنید',
      translateTips:
        'نکته: اگر ترجمه کمی طول می کشد، می توانید این پنجره را ببندید و بعداً به اشتراک بگذارید.',
      translating: 'ترجمه پی دی اف...',
      update: 'به روز رسانی لینک اشتراک گذاری',
    },
    shareMsg1: 'پیوند ایجاد شده را به اشتراک بگذارید.',
    shareMsg2: 'محتوای مشترک به روز شد.',
    shareMsg3:
      'پیوند اشتراک‌گذاری ایجاد نشد. لطفاً بعداً دوباره امتحان کنید یا با پشتیبانی تماس بگیرید.',
    shareMsg4:
      'محتوای مشترک به‌روزرسانی نشد. لطفاً بعداً دوباره امتحان کنید یا با پشتیبانی تماس بگیرید.',
    shareTips: 'ترجمه PDF شما آماده است! آن را با دوستان خود به اشتراک بگذارید.',
    start: 'آزمایشی رایگان خود را شروع کنید',
    thumbnail: 'فهرست مطالب',
    toast1: 'در حال بارگیری PDF. لطفاً بعداً دوباره امتحان کنید.',
    toast2: 'محتوای PDF خیلی بزرگ است. گفتگو در حال حاضر پشتیبانی نمی شود.',
    toast3: 'در حال دانلود. لطفا پس از پایان دانلود دوباره امتحان کنید.',
    toolbar: { Adjust: 'تنظیم کنید', autoFit: 'تناسب خودکار' },
    trans: 'ترجمه',
    transSucc: 'ترجمه موفق شد!',
    unLoginToast: 'لطفا برای استفاده از این قابلیت وارد شوید.',
    uploadBtn: 'آپلود کنید',
    uploadErr: 'آپلود فایل انجام نشد. لطفاً بعداً دوباره امتحان کنید یا با پشتیبانی تماس بگیرید.',
    uploadMsg1: 'فایل خود را اینجا بکشید و رها کنید.',
    uploadMsg2: 'انواع فایل های پشتیبانی شده: PDF |  حداکثر حجم فایل: 100 مگابایت',
    uploadMsg3: 'برای انتخاب یا کشیدن و رها کردن فایل ها در اینجا کلیک کنید.',
    uploading: 'در حال آپلود',
    uploadingMsg: 'در حال آپلود. لطفا صبر کنید.',
    uploadingMsg1: 'فایل در حال آپلود است لطفاً بعداً دوباره امتحان کنید.',
    uploadingMsg2: 'در حال حاضر یک فایل در حال تبدیل است. لطفاً بعداً دوباره امتحان کنید.',
    uploadingMsg3:
      'درخواست پیشرفت تبدیل ناموفق بود. لطفاً بعداً دوباره امتحان کنید یا با پشتیبانی تماس بگیرید.',
    uploadingMsg4:
      'Noam نمی تواند به فایل های محلی دسترسی پیدا کند. لطفا به صورت دستی یک PDF برای ترجمه آپلود کنید.',
    uploadingMsg5:
      'URL فایل بازیابی نشد. لطفاً بعداً دوباره امتحان کنید یا با پشتیبانی تماس بگیرید.',
    video: 'ویدئو',
    vipBannerBtn: 'ارتقا دهید',
    vipBannerTips: 'شما به حد مجاز ترجمه PDF خود برای این ماه رسیده اید.',
    webTrans: 'مرجع کامل',
  },
  pricing: {
    FAQ: 'سوالات متداول',
    FQAObj: {
      a1: 'بله، Noam یک طرح رایگان ارائه می دهد که می توانید بلافاصله از آن استفاده کنید.',
      a2: 'ما سه طرح عضویت ارائه می دهیم: Pro، Pro+، و Enterprise. می توانید پرداخت ماهانه یا سالانه را انتخاب کنید. صورتحساب سالانه صرفه جویی قابل توجهی را ارائه می دهد.',
      a3: 'همه ویژگی ها در هر دو پلن موجود است. تفاوت اصلی در هزینه است: هزینه اشتراک سالانه به طور کلی کمتر است. صورت‌حساب اشتراک‌های ماهانه هر ماه محاسبه می‌شود، در حالی که صورت‌حساب طرح‌های سالانه یک بار در سال انجام می‌شود.',
      a4: 'هر زمان که بخواهید می توانید اشتراک خود را در تنظیمات حساب خود لغو کنید.',
      q1: 'آیا طرح رایگان وجود دارد؟',
      q2: 'چه طرح های قیمت گذاری و گزینه های پرداخت موجود است؟',
      q3: 'تفاوت بین اشتراک ماهانه با سالانه چیست؟',
      q4: 'چگونه اشتراک خود را لغو کنم؟',
    },
    around: 'در اطراف',
    billedMonthly: 'صورتحساب ماهانه',
    billedYearly: 'صورتحساب سالانه',
    day: 'روز',
    desc: 'مقایسه طرح ها و انتخاب بهترین ها',
    detailedCompare: 'مقایسه طرح ها',
    discount: '20% تخفیف',
    enterprise: {
      benefit1: 'اولویت پشتیبانی مشتری',
      benefit2: 'چند کاربر',
      benefit3: 'راه حل های سفارشی',
      benefit5: 'مدیر حساب اختصاصی',
      btn: 'تماس با ما',
      recommendText: 'طرح های سفارشی (≥3人)',
      talkToUs: 'تماس بگیرید',
    },
    free: {
      benefit1: 'ترجمه فوری 100 بار در روز',
      benefit2: 'ترجمه و خلاصه وب سایت',
      benefit3: '30 ترجمه تصویر',
      benefit4: 'ترجمه و خلاصه ویدیو',
      benefit5: '10 ترجمه PDF',
      benefit6: '5000 توکن',
      btn: 'آن را رایگان امتحان کنید',
      recommendText: 'آزمایشی رایگان',
    },
    imageTranslation: 'ترجمه تصویر',
    month: 'ماه',
    monthly: 'ماهانه',
    pageTitle: 'قیمت گذاری',
    pdf: {
      chat: 'پرس و جوهای چت PDF',
      maxPage: 'حداکثر صفحات در هر پی دی اف',
      translation: 'ترجمه PDF',
    },
    preMonth: 'در هر ماه',
    pro: {
      benefit1: 'اولویت پشتیبانی مشتری',
      benefit2: '1,000,000 توکن در ماه',
      benefit3: 'ترجمه و خلاصه وب سایت',
      benefit4: '200 ترجمه تصویر',
      benefit5: 'ترجمه و خلاصه ویدیو',
      benefit6: '200 ترجمه PDF',
      btn: 'شروع کنید',
      recommendText: 'محبوب ترین',
    },
    proPlus: {
      benefit1: 'اولویت پشتیبانی مشتری',
      benefit2: '3,000,000 توکن در ماه',
      benefit3: 'ترجمه و خلاصه وب سایت',
      benefit4: '500 ترجمه تصویر',
      benefit5: 'ترجمه و خلاصه ویدیو',
      benefit6: '500 ترجمه PDF',
      recommendText: 'بهترین ارزش',
    },
    video: { summary: 'خلاصه ویدیو', translation: 'ترجمه ویدیویی' },
    web: {
      contrastiveTranslation: 'ترجمه دو زبانه',
      dictionaryTranslation: 'ترجمه انتخابی',
      hoverTranslation: 'ترجمه شناور',
      instantTranslation: 'ترجمه فوری',
      summary: 'خلاصه صفحه وب',
    },
    yearly: 'سالانه',
  },
  privacy: {
    block1:
      'نوام («نوام»، «ما»، «ما» یا «ما») به حریم خصوصی شما احترام می‌گذارد و متعهد است از هرگونه اطلاعاتی که از شما یا درباره شما به دست می‌آوریم محافظت کند. این سیاست حفظ حریم خصوصی، شیوه‌های ما را در مورد جمع‌آوری یا استفاده از اطلاعات شخصی ناشی از استفاده شما از وب‌سایت، برنامه‌ها و خدمات ما (در مجموع «سرویس‌ها») توضیح می‌دهد. این خط‌مشی رازداری در مورد محتوایی که ما از طرف مشتریان محصول تجاری خود مدیریت می‌کنیم، مانند API اعمال نمی‌شود. استفاده از این داده ها منوط به توافق مشتری ما است که دسترسی و استفاده از این محصولات را پوشش می دهد.',
    block10:
      'ما اقدامات فنی، اداری و سازمانی منطقی تجاری را برای محافظت از اطلاعات شخصی آنلاین و آفلاین در برابر از دست دادن، سوء استفاده، و دسترسی غیرمجاز، افشا، تغییر یا اعمال خصمانه اجرا می کنیم. با این حال، هیچ انتقال اینترنتی یا ایمیلی نمی تواند امنیت یا دقت کامل را تضمین کند. به ویژه، ایمیل هایی که برای ما یا از طرف ما ارسال می شوند ممکن است ایمن نباشند. بنابراین، هنگام تصمیم گیری درباره اینکه چه اطلاعاتی را از طریق سرویس یا ایمیل برای ما ارسال کنید، باید به ویژه مراقب باشید. علاوه بر این، ما مسئولیتی در قبال هرگونه مانعی در تنظیمات حریم خصوصی یا اقدامات امنیتی در سرویس یا تنظیمات امنیتی یا اقدامات امنیتی وب سایت های شخص ثالث نداریم. ما اطلاعات شخصی شما را تا زمانی که برای ارائه خدمات به شما یا سایر مقاصد تجاری مشروع، مانند حل و فصل اختلافات، دلایل امنیتی و ایمنی، یا پیروی از تعهدات قانونی خود لازم باشد، حفظ خواهیم کرد. مدت زمانی که ما اطلاعات شخصی را حفظ می کنیم به عوامل زیادی مانند مقدار، ماهیت، حساسیت اطلاعات، خطرات احتمالی استفاده یا افشای غیرمجاز، اهداف پردازش اطلاعات و سایر ملاحظات الزام آور قانونی بستگی دارد.',
    block11:
      'ممکن است هر از چند گاهی این سیاست حفظ حریم خصوصی را به روز کنیم. هنگامی که این کار را انجام دهیم، نسخه به روز شده ای را در این صفحه پست می کنیم، مگر اینکه قانون قابل اجرا خلاف آن را الزامی کند.',
    block12:
      'اگر سؤال یا نگرانی بی پاسخی در مورد این سیاست حفظ حریم خصوصی دارید، لطفاً با خدمات مشتریان ما تماس بگیرید. ایمیل:',
    block2: 'ما اطلاعات شخصی زیر ("اطلاعات شخصی") مربوط به شما را جمع آوری می کنیم:',
    block3:
      'اطلاعات ارائه شده توسط شما: هنگامی که برای استفاده از خدمات ما یا برقراری ارتباط با ما حساب کاربری ایجاد می کنید، اطلاعات شخصی را به شرح زیر جمع آوری می کنیم:',
    block4:
      'اطلاعات شخصی که به‌طور خودکار از استفاده شما از خدمات دریافت می‌شود: هنگامی که به سرویس‌ها دسترسی دارید، استفاده می‌کنید یا با آن‌ها تعامل دارید، اطلاعات زیر را در مورد دسترسی، استفاده یا تعامل شما دریافت می‌کنیم ("اطلاعات فنی"):',
    block5: 'ما ممکن است از اطلاعات شخصی برای اهداف زیر استفاده کنیم:',
    block6:
      'خلاصه یا اطلاعات شناسایی‌شده: ممکن است اطلاعات شخصی را جمع‌آوری یا حذف کنیم تا از استفاده مجدد آن برای اهداف شناسایی جلوگیری کنیم و از چنین اطلاعاتی برای تجزیه و تحلیل اثربخشی خدماتمان، بهبود و افزودن ویژگی‌ها به خدماتمان، انجام تحقیقات و اهداف مشابه استفاده کنیم. . علاوه بر این، ممکن است رفتار و ویژگی‌های عمومی کاربران سرویس خود را تجزیه و تحلیل کنیم و اطلاعات جمع‌آوری شده را با اشخاص ثالث به اشتراک بگذاریم، چنین اطلاعات انبوهی را منتشر کنیم یا آن را به طور کلی در دسترس قرار دهیم. ما ممکن است اطلاعات جمع آوری شده را از طریق سرویس ها، از طریق کوکی ها، و از طریق دیگر روش های شرح داده شده در این سیاست حفظ حریم خصوصی جمع آوری کنیم. ما اطلاعات شناسایی نشده را به شکلی ناشناس یا بدون هویت حفظ می کنیم و از آنها استفاده می کنیم و تلاشی برای شناسایی مجدد چنین اطلاعاتی نمی کنیم مگر اینکه طبق قانون الزامی شود.',
    block7:
      'در برخی موارد، ما ممکن است اطلاعات شخصی شما را بدون اطلاع بیشتر به شما در اختیار اشخاص ثالث قرار دهیم، مگر اینکه طبق قانون الزامی باشد:',
    block8:
      'بسته به موقعیت جغرافیایی شما، افراد در منطقه اقتصادی اروپا، بریتانیا و در سطح جهان ممکن است از حقوق قانونی خاصی در مورد اطلاعات شخصی خود برخوردار باشند. برای مثال، ممکن است حق داشته باشید:',
    block9:
      'این سرویس ممکن است حاوی پیوندهایی به وب‌سایت‌های دیگری باشد که توسط Noam اداره یا کنترل نمی‌شوند، از جمله خدمات رسانه‌های اجتماعی («وب‌سایت‌های شخص ثالث»). اطلاعاتی که با وب‌سایت‌های شخص ثالث به اشتراک می‌گذارید، توسط سیاست‌های حفظ حریم خصوصی و شرایط خدمات وب‌سایت‌های شخص ثالث کنترل می‌شود، نه این سیاست حفظ حریم خصوصی. ما این پیوندها را برای سهولت ارائه می کنیم و به معنای تایید یا بررسی این وب سایت ها نیستیم. لطفاً برای اطلاع از خط مشی ها و شرایط حفظ حریم خصوصی با وب سایت های شخص ثالث مستقیماً تماس بگیرید.',
    subBlock1:
      'اطلاعات حساب: هنگامی که یک حساب کاربری در پلتفرم ما ایجاد می کنید، اطلاعات مربوط به حساب شما، از جمله نام، اطلاعات تماس، اعتبار حساب، اطلاعات کارت پرداخت و سابقه تراکنش ("اطلاعات حساب") را جمع آوری می کنیم.',
    subBlock10: 'ارائه، مدیریت، نگهداری و/یا تجزیه و تحلیل خدمات؛',
    subBlock11: 'ارتباط با شما؛',
    subBlock12: 'توسعه محصولات و خدمات جدید؛',
    subBlock13:
      'جلوگیری از کلاهبرداری، فعالیت مجرمانه، یا سوء استفاده از خدمات ما، و حفاظت از امنیت سیستم‌های فناوری اطلاعات، معماری، و شبکه‌های ما؛',
    subBlock14: 'انجام نقل و انتقالات تجاری؛',
    subBlock15:
      'پیروی از تعهدات قانونی و روندهای قانونی، حفاظت از حقوق، حریم خصوصی، امنیت، یا دارایی ما، و همچنین شرکای وابسته به ما، شما یا سایر اشخاص ثالث.',
    subBlock16:
      'تامین کنندگان و ارائه دهندگان خدمات: برای کمک به ما در رفع نیازهای عملیاتی کسب و کار و انجام خدمات و عملکردهای خاص، ممکن است اطلاعات شخصی را در اختیار تامین کنندگان و ارائه دهندگان خدمات، از جمله ارائه دهندگان خدمات میزبانی، ارائه دهندگان خدمات ابری، و سایر ارائه دهندگان خدمات فناوری اطلاعات، نرم افزار ارتباط ایمیلی قرار دهیم. و ارائه دهندگان خدمات تجزیه و تحلیل وب، و غیره. این شرکا در حین انجام وظایف خود برای ما، فقط به دستور ما به اطلاعات شخصی دسترسی، پردازش یا ذخیره خواهند کرد.',
    subBlock17:
      'نقل و انتقالات تجاری: اگر در معاملات استراتژیک، سازمان‌دهی مجدد، ورشکستگی، تصاحب ورشکستگی، یا انتقال خدمات به ارائه‌دهنده دیگری (مجموعاً «معاملات») شرکت کنیم، ممکن است اطلاعات شخصی و سایر اطلاعات شما با همتایان تراکنش و سایر طرف‌هایی که در تراکنش‌ها کمک می‌کنند به اشتراک گذاشته شود. طی بررسی لازم و به عنوان بخشی از معاملات همراه با سایر دارایی ها به جانشین یا شرکت وابسته منتقل می شود.',
    subBlock18:
      'الزامات قانونی: ما ممکن است اطلاعات شخصی شما را با مقامات دولتی، همتایان صنعت یا سایر اشخاص ثالث به اشتراک بگذاریم، از جمله اطلاعات تعامل شما با خدمات ما، (1) در صورتی که طبق قانون لازم باشد یا اگر فکر کنیم چنین اقدامی برای رعایت تعهدات قانونی ضروری است. (2) برای محافظت و دفاع از حقوق یا دارایی خود؛ (3) اگر به طور یکجانبه تشخیص دهیم که شرایط، خط‌مشی‌ها یا قوانین ما نقض شده است. (4) برای کشف یا جلوگیری از تقلب یا سایر فعالیت های غیرقانونی؛ (5) برای محافظت از محصولات، کارکنان، یا کاربران، یا امنیت عمومی، امنیت، یکپارچگی. یا (vi) برای دفاع در برابر مسئولیت قانونی.',
    subBlock19: 'به اطلاعات شخصی و اطلاعات مربوط به نحوه پردازش آنها دسترسی داشته باشید.',
    subBlock2:
      'محتوای کاربر: هنگامی که از خدمات ما استفاده می کنید، اطلاعات شخصی را از ورودی ها، آپلود فایل ها یا بازخوردهای ارائه شده به ما ("محتوا") جمع آوری می کنیم.',
    subBlock20: 'درخواست حذف اطلاعات شخصی خود را از سوابق ما.',
    subBlock21: 'اطلاعات شخصی خود را تصحیح یا به روز کنید.',
    subBlock22: 'اطلاعات شخصی خود را به شخص ثالث منتقل کنید (قابلیت انتقال داده).',
    subBlock23: 'نحوه پردازش اطلاعات شخصی شما را محدود کنید.',
    subBlock24:
      'رضایت خود را پس بگیرید—در جایی که ما بر رضایت به عنوان مبنای قانونی برای پردازش تکیه می‌کنیم، می‌توانید در هر زمان رضایت خود را پس بگیرید.',
    subBlock25: 'به نحوه پردازش اطلاعات شخصی شما اعتراض کنید.',
    subBlock26: 'بهبود خدمات و انجام تحقیقات؛',
    subBlock3:
      'اطلاعات ارتباطی: اگر برای ما پیام ارسال کنید، نام، اطلاعات تماس و محتوای پیام های شما ("اطلاعات ارتباطی") را جمع آوری می کنیم.',
    subBlock4:
      'اطلاعات رسانه های اجتماعی: ما صفحاتی در وب سایت های رسانه های اجتماعی مانند اینستاگرام، فیس بوک، مدیوم، توییتر، یوتیوب و لینکدین داریم. هنگامی که شما با صفحات رسانه های اجتماعی ما تعامل می کنید، اطلاعات شخصی را که انتخاب می کنید به ما ارائه دهید، مانند اطلاعات تماس شما ("اطلاعات اجتماعی") جمع آوری می کنیم. به‌علاوه، شرکت‌هایی که صفحات رسانه‌های اجتماعی ما را میزبانی می‌کنند ممکن است اطلاعات و تحلیل‌های انبوهی درباره فعالیت‌های رسانه‌های اجتماعی ما در اختیار ما قرار دهند.',
    subBlock5:
      'Log Data: اطلاعاتی که به طور خودکار توسط مرورگر شما هنگام استفاده از خدمات ما ارسال می شود. داده‌های گزارش شامل آدرس پروتکل اینترنت (IP)، نوع مرورگر و تنظیمات، تاریخ و زمان درخواست‌های شما و نحوه تعامل شما با وب‌سایت ما است.',
    subBlock6:
      'داده‌های استفاده: ممکن است به‌طور خودکار اطلاعاتی درباره استفاده شما از این سرویس جمع‌آوری کنیم، مانند انواع محتوایی که مشاهده می‌کنید یا با آن تعامل دارید، ویژگی‌هایی که استفاده می‌کنید، اقداماتی که انجام می‌دهید، و همچنین منطقه زمانی، کشور، تاریخ و زمان شما. دسترسی، عامل کاربر و نسخه، نوع رایانه یا دستگاه تلفن همراه، و اتصال رایانه شما.',
    subBlock7:
      'اطلاعات دستگاه: این شامل نام دستگاه، سیستم عامل، شناسه دستگاه و مرورگری است که استفاده می کنید. اطلاعات جمع آوری شده ممکن است به نوع دستگاهی که استفاده می کنید و تنظیمات آن بستگی داشته باشد.',
    subBlock8:
      'کوکی ها: ما از کوکی ها برای کار و مدیریت خدمات خود و بهبود تجربه شما استفاده می کنیم. "کوکی" اطلاعاتی است که توسط وب سایتی که بازدید می کنید به مرورگر شما ارسال می شود. می‌توانید مرورگر خود را طوری تنظیم کنید که همه کوکی‌ها را بپذیرد، همه کوکی‌ها را رد کند یا زمانی که یک کوکی ارائه می‌شود به شما اطلاع دهد تا بتوانید هر بار تصمیم بگیرید که آن را بپذیرید. با این حال، امتناع از کوکی‌ها ممکن است مانع استفاده شما شود یا بر نمایش یا عملکرد برخی مناطق یا ویژگی‌های وب‌سایت تأثیر منفی بگذارد. برای اطلاعات بیشتر در مورد کوکی ها، لطفاً از همه چیز درباره کوکی ها دیدن کنید.',
    subBlock9:
      'تجزیه و تحلیل: ما ممکن است از محصولات مختلف تجزیه و تحلیل آنلاین استفاده کنیم که از کوکی ها استفاده می کنند تا به ما کمک کنند تا نحوه استفاده کاربران از خدمات ما را تجزیه و تحلیل کنیم و تجربه شما را هنگام استفاده از خدمات بهبود بخشیم.',
    subTitle1: 'اطلاعات شخصی که ما جمع آوری می کنیم',
    subTitle2: 'چگونه از اطلاعات شخصی استفاده می کنیم',
    subTitle3: 'افشای اطلاعات شخصی',
    subTitle4: 'حقوق شما',
    subTitle5: 'پیوند به وب سایت های دیگر',
    subTitle6: 'امنیت و نگهداری اطلاعات',
    subTitle7: 'اصلاح سیاست حفظ حریم خصوصی',
    subTitle8: 'نحوه تماس با ما',
    title: 'سیاست حفظ حریم خصوصی',
    updateTime: 'به روز شده: 15 مارس 2024',
  },
  privacyCollectionPanel: {
    acceptBtn: 'همه را بپذیر',
    text: 'برای بهبود تجربه شما، از کوکی ها برای شخصی سازی محتوا و خدمات استفاده می کنیم.',
    title: 'این وب سایت از کوکی ها استفاده می کند',
  },
  slogen: 'ساده ترین دستیار هوش مصنوعی',
  stripe: {
    contact: 'در صورت هرگونه سوال با ما در contact@noam.tools تماس بگیرید!',
    fail: {
      btn: 'دوباره امتحان کنید',
      text1: 'ما نتوانستیم پرداخت شما را پردازش کنیم.',
      text2: 'اتصال خود را بررسی کنید و دوباره امتحان کنید.',
      title: 'پرداخت انجام نشد',
    },
    succ: {
      btn: 'بیا برویم',
      text1: 'به نوام خوش آمدید،',
      text2: 'بیایید شروع کنیم!',
      title: 'تبریک میگم',
    },
  },
  terms: {
    block1: 'از اینکه از Noam استفاده کردید متشکرم!',
    block10:
      '(الف) هزینه ها و صورتحساب. شما تمام هزینه ها ("هزینه ها") را طبق قیمت و شرایط مندرج در صفحه قیمت گذاری قابل اجرا یا طبق توافق نامه کتبی بین ما پرداخت خواهید کرد. ما حق تصحیح اشتباهات یا اشتباهات قیمت گذاری را برای خود محفوظ می داریم حتی اگر فاکتورهایی صادر کرده باشیم یا پرداختی را دریافت کرده باشیم. اطلاعات صورت‌حساب کامل و دقیق، از جمله روش پرداخت معتبر و مجاز را ارائه می‌دهید. طبق توافق، از روش پرداخت شما به صورت دوره‌ای هزینه دریافت می‌کنیم، اما ممکن است تاریخ صورت‌حساب را به طور منطقی تغییر دهیم. شما به Noam، شرکت‌های وابسته آن و پردازنده‌های پرداخت شخص ثالث اجازه می‌دهید که از روش پرداخت شما هزینه کسر کنند. اگر پرداخت شما ناموفق باشد، اخطار کتبی به شما ارائه خواهیم کرد و ممکن است دسترسی به سرویس را تا زمان دریافت پرداخت به حالت تعلیق در آوریم. به جز مواردی که در این توافقنامه مشخص شده باشد، پرداخت ها غیر قابل استرداد هستند.',
    block11:
      '(ب) مالیات. جز در مواردی که خلاف آن ذکر شده باشد، هزینه ها شامل هیچ گونه مالیات، عوارض و ارزیابی های مشابه فدرال، ایالتی، محلی و خارجی نمی شود ("مالیات"). شما مسئول تمام مالیات های مرتبط با خریدهای خود هستید، به استثنای مالیات های بر اساس درآمد خالص ما که برای شما فاکتور می گیریم. شما موافقت می‌کنید که به سرعت چنین مالیات‌هایی را بپردازید و بیانیه‌های حریم خصوصی معتبر قانونی را به ما ارائه دهید و رضایت‌های لازم را برای رسیدگی به این داده‌ها دریافت کنید، و به ما ضمانت می‌دهید که با این داده‌ها مطابق با قانون قابل اجرا رفتار می‌کنید.',
    block12:
      '(ج) تغییرات قیمت. ما ممکن است با اطلاع دادن به شما از طریق حساب و/یا وب سایت خود، قیمت های خود را تغییر دهیم. افزایش قیمت بلافاصله پس از ارسال اعمال خواهد شد. هر گونه تغییر قیمت پس از تاریخ لازم الاجرا شدن تغییر، برای کارمزد حساب شما اعمال خواهد شد.',
    block13:
      'د) اختلافات و پرداخت های معوق. اگر مایل به مخالفت با هر گونه هزینه یا مالیات هستید، لطفاً ظرف سی (30) روز از تاریخ فاکتور با contact@noam.tools تماس بگیرید.',
    block14:
      '(ه) استفاده رایگان. شما نمی توانید چندین حساب برای به دست آوردن اعتبار رایگان ایجاد کنید. اگر تشخیص دهیم که شما با حسن نیت از اعتبارات رایگان استفاده نمی کنید، ممکن است هزینه های استانداردی از شما دریافت کنیم یا دسترسی به سرویس را متوقف کنیم.',
    block15:
      '(الف) محرمانه بودن ممکن است به اطلاعات محرمانه Noam دسترسی داشته باشید. شما فقط می توانید از اطلاعات محرمانه که طبق این شرایط مجاز است برای استفاده از سرویس استفاده کنید. شما نمی توانید اطلاعات محرمانه را در اختیار هیچ شخص ثالثی قرار دهید، و از اطلاعات محرمانه به گونه ای محافظت خواهید کرد که کمتر از محافظت از اطلاعات محرمانه مشابه خود، حداقل با دقت معقول، محافظت می کند. اطلاعات محرمانه اطلاعات غیر عمومی است که توسط Noam به عنوان محرمانه تعیین شده است یا به طور منطقی باید تحت شرایطی محرمانه تلقی شود، از جمله نرم افزار، مشخصات و سایر اطلاعات تجاری غیر عمومی. اطلاعات محرمانه شامل اطلاعاتی نمی شود که: (1) به طور کلی بدون تقصیر شما در دسترس عموم قرار می گیرد. (2) قبل از دریافت آن تحت این شرایط، بدون هیچ گونه تعهد محرمانه در اختیار شما بود. (3) به طور قانونی توسط شخص ثالث بدون هیچ گونه تعهد محرمانه برای شما افشا شده است. یا (4) به طور مستقل توسط شما بدون استفاده از اطلاعات محرمانه توسعه یافته است. در صورت لزوم قانون، دادگاه یا سایر دستورات دولتی، می‌توانید اطلاعات محرمانه را فاش کنید، اما باید به نوام اخطار کتبی قبلی را به شیوه‌ای معقول ارائه دهید و تا حد امکان، تلاش‌های منطقی برای محدود کردن دامنه افشا، از جمله کمک به ما انجام دهید. در مخالفت با درخواست های افشاگری',
    block16:
      '(ب) امنیت. شما باید تدابیر معقول و مناسبی را برای کمک به محافظت از دسترسی و استفاده از سرویس به کار ببندید. اگر هر گونه آسیب‌پذیری یا نقض مرتبط با استفاده از سرویس را کشف کردید، باید فوراً با Noam تماس بگیرید و جزئیات آسیب‌پذیری یا نقض را ارائه دهید.',
    block17:
      '(ج) پردازش داده‌های شخصی. اگر از این سرویس برای پردازش داده‌های شخصی استفاده می‌کنید، باید بیانیه‌های حریم خصوصی کافی از نظر قانونی ارائه کنید و رضایت لازم را برای پردازش این داده‌ها کسب کنید، و به ما ضمانت می‌دهید که با این داده‌ها مطابق با قانون قابل اجرا رفتار کنید. .',
    block18:
      'الف) فسخ؛ تعلیق. این شرایط از اولین استفاده شما از این سرویس قابل اجرا خواهد بود و تا زمان خاتمه آن به قوت خود باقی خواهد ماند. شما می توانید این شرایط را در هر زمانی به هر دلیلی با قطع استفاده از سرویس و محتوا خاتمه دهید. ممکن است به هر دلیلی این شرایط را با اطلاع قبلی فسخ کنیم. در صورت نقض مادی بخش 2 (شرایط استفاده)، بخش 5 (محرمانه، امنیت و حفاظت از داده ها)، بخش 8 (حل اختلاف)، یا بخش 9 (شرایط عمومی)، یا ارتباط با هر ارائه‌دهنده فناوری شخص ثالثی که خارج از کنترل ما است، یا برای انطباق با قانون یا درخواست‌های دولتی. اگر شما از این شرایط پیروی نکنید، یا اگر استفاده شما برای ما یا هر شخص ثالثی خطری امنیتی ایجاد کند، یا اگر گمان کنیم استفاده شما تقلبی است یا ممکن است ما یا هر شخص ثالثی را در معرض مسئولیت قرار دهد، ممکن است دسترسی شما به سرویس را به حالت تعلیق در آوریم. .',
    block19:
      '(ب) آثار فسخ. پس از خاتمه، استفاده از سرویس را متوقف خواهید کرد و هر گونه اطلاعات محرمانه را طبق دستور ما فوراً بازگردانید یا از بین خواهید برد. مفاد این شرایط که طبیعتاً باید پس از پایان یا انقضا باقی بماند، شامل بخش‌های 3 و 5-9، اما نه محدود به آن، باقی خواهد ماند.',
    block2:
      'این شرایط استفاده در مورد استفاده شما از خدمات Noam، از جمله رابط های برنامه نویسی کاربردی، نرم افزار، ابزار، خدمات توسعه دهنده، داده ها، اسناد، و وب سایت ما (که در مجموع به عنوان "سرویس ها" نامیده می شود) اعمال می شود. با استفاده از خدمات ما، شما موافقت می کنید که این شرایط را رعایت کنید. خط مشی رازداری ما نحوه جمع آوری و استفاده از اطلاعات شخصی را توضیح می دهد.',
    block20:
      'الف) غرامت. شما از ما، شرکت‌های وابسته و پرسنل ما دفاع، غرامت می‌دهید، و از ما و کارکنان ما در برابر هرگونه ادعا، ضرر و هزینه (از جمله حق الوکاله) ناشی از یا مربوط به استفاده شما از سرویس، از جمله محتوای شما استفاده از محصولات یا خدمات مرتبط با سرویس و نقض این شرایط یا قانون قابل اجرا توسط شما.',
    block21:
      '(ب) سلب مسئولیت. سرویس "همانطور که هست" ارائه می شود. تا جایی که قانون اجازه می‌دهد، ما و شرکت‌های وابسته و مجوزدهنده‌های ما هیچ گونه نمایندگی یا ضمانت‌نامه‌ای در رابطه با سرویس ارائه نمی‌کنیم و هیچ ضمانتی، شامل اما نه محدود به ضمانت‌های تجاری بودن، مناسب بودن برای یک هدف خاص، کیفیت رضایت‌بخش، عدم نقض ، و لذت بی سر و صدا، و هر گونه ضمانت نامه ناشی از معامله یا استفاده از تجارت. ما تضمین نمی‌کنیم که سرویس بدون وقفه، دقیق یا بدون خطا باشد، یا هر محتوایی امن باشد، از بین نرود یا تغییری در آن ایجاد نشود.',
    block22:
      'ج) محدودیت مسئولیت. نه ما، شرکت‌های وابسته و نه صادرکنندگان مجوز ما مسئولیتی در قبال خسارات غیرمستقیم، اتفاقی، خاص، تبعی یا کیفری، از جمله از دست دادن سود، از دست دادن شهرت، از دست دادن استفاده، از دست دادن داده‌ها، یا سایر زیان‌های نامشهود نخواهیم داشت، حتی اگر به ما در مورد احتمال چنین آسیب هایی توصیه شده است. طبق این شرایط، کل بدهی ما از هزینه‌هایی که در دوازده (12) ماه قبل از ادعا به سرویس پرداخت کرده‌اید یا از صد دلار آمریکا (100 دلار) تجاوز نخواهد کرد. محدودیت های موجود در این بخش تا حداکثر میزان مجاز توسط قانون قابل اجرا اعمال می شود.',
    block23:
      'شرایط و استفاده شما از خدمات، به جز قوانین تضاد قوانین ایالات متحده، تحت قوانین ایالات متحده است. استفاده شما از برنامه ممکن است مشمول سایر قوانین محلی، ایالتی، ملی یا بین المللی نیز باشد. هرگونه اقدام حقوقی یا دادرسی مربوط به این شرایط منحصراً در دادگاه های ایالات متحده انجام می شود و شما موافقت می کنید که به صلاحیت شخصی چنین دادگاه هایی تسلیم شوید.',
    block24:
      'الف) روابط طرفین. نوام و شما پیمانکاران مستقلی هستید و هیچ یک از طرفین بدون رضایت قبلی کتبی طرف مقابل، قدرت نمایندگی یا تعهد طرف مقابل یا متعهد شدن تعهدات برای طرف مقابل را ندارد.',
    block25:
      '(ب) استفاده از برند. شما مجاز به استفاده از نام، نشان‌واره یا علائم تجاری Noam یا هر یک از شرکت‌های وابسته به آن بدون رضایت کتبی قبلی ما نیستید.',
    block26:
      'اگر هر یک از مفاد این شرایط نامعتبر، غیرقانونی یا غیرقابل اجرا تشخیص داده شود، مفاد باقی مانده به قوت خود باقی خواهد ماند.',
    block3:
      'اگر زیر 18 سال سن دارید، برای استفاده از این سرویس باید از والدین یا قیم قانونی خود اجازه بگیرید. اگر از طرف شخص یا نهاد دیگری از این سرویس استفاده می کنید، باید از طرف آنها مجاز به پذیرش این شرایط باشید. برای ثبت نام در حساب کاربری باید اطلاعات دقیق و کاملی ارائه دهید. شما نمی توانید اعتبار دسترسی یا حساب کاربری خود را در اختیار افراد خارج از سازمان خود قرار دهید، و مسئولیت تمام فعالیت هایی که با استفاده از اعتبار شما انجام می شود، بر عهده شماست.',
    block4:
      '(الف) استفاده از خدمات. شما ممکن است تحت این شرایط به سرویس دسترسی داشته باشید، و ما به شما حق غیر انحصاری استفاده از این سرویس را می دهیم. هنگام استفاده از این سرویس، از این شرایط و کلیه قوانین قابل اجرا پیروی خواهید کرد. ما و وابستگانمان دارای کلیه حقوق، عناوین و منافع در سرویس هستیم.',
    block5:
      '(ب) بازخورد. ما از بازخورد، نظرات، ایده ها، پیشنهادات و پیشرفت ها استقبال می کنیم. در صورت ارائه چنین محتوایی، ما ممکن است بدون هیچ محدودیتی و بدون پرداخت خسارت به شما از آن استفاده کنیم.',
    block6:
      '(ج) محدودیت ها. شما نمی توانید: (1) از خدمات به گونه ای استفاده کنید که حقوق دیگران را نقض کند، سوء استفاده کند یا نقض کند. (2) مهندسی معکوس، دکامپایل، جداسازی، ترجمه، یا تلاش برای کشف کد منبع یا مؤلفه‌های زیربنایی مدل‌ها، الگوریتم‌ها و سیستم‌های سرویس (مگر اینکه چنین محدودیت‌هایی توسط قانون قابل اجرا ممنوع شده باشد). (3) از خروجی سرویس برای توسعه مدل های رقابت با نوام استفاده کنید. (4) استخراج داده یا خروجی از سرویس با استفاده از هر روش خودکار یا برنامه نویسی، مگر اینکه از طریق API مجاز باشد، از جمله خراش دادن، برداشت وب، یا استخراج داده های وب؛ (5) خروجی سرویس را به‌عنوان تولید مصنوعی نشان دهید در حالی که اینطور نیست، یا به‌طور دیگری خط‌مشی‌های استفاده ما را نقض می‌کند. (6) خرید، فروش، یا انتقال کلیدهای API بدون رضایت قبلی ما؛ یا (7) هرگونه اطلاعات شخصی کودکان زیر 13 سال یا سن قانونی رضایت دیجیتال را در اختیار ما قرار دهید. شما با هرگونه محدودیت نرخ و سایر الزامات موجود در اسناد ما مطابقت خواهید داشت.',
    block7:
      '(د) خدمات شخص ثالث. هر نرم‌افزار، خدمات یا سایر محصولات شخص ثالث مرتبط با سرویس، تحت شرایط خاص خود است و ما مسئولیتی در قبال محصولات شخص ثالث نداریم.',
    block8:
      '(الف) محتوای شما. شما می توانید ورودی ("ورودی") را به سرویس ارائه دهید و خروجی ("خروجی") تولید شده و بر اساس ورودی (که در مجموع به عنوان "محتوا" نامیده می شود) را دریافت کنید. بین طرفین و تا حدی که قانون قابل اجرا اجازه می دهد، شما مالک تمام ورودی ها هستید. Noam ممکن است از محتوا برای ارائه و حفظ سرویس، پیروی از قوانین قابل اجرا و اجرای خط‌مشی‌های ما استفاده کند. شما در قبال محتوا مسئول هستید، از جمله اطمینان حاصل کنید که قوانین قابل اجرا یا این شرایط را نقض نمی کند.',
    block9:
      '(ب) دقت. هوش مصنوعی و یادگیری ماشینی زمینه های تحقیقاتی به سرعت در حال توسعه هستند. ما به طور مستمر در تلاش هستیم تا خدمات خود را برای دقیق تر، قابل اعتماد تر، ایمن تر و سودمندتر کنیم. با توجه به ماهیت احتمالی یادگیری ماشینی، استفاده از سرویس ما ممکن است در موارد خاص منجر به خروجی های نادرست شود که ممکن است به درستی افراد، مکان ها یا حقایق واقعی را منعکس نکند. شما باید دقت هر خروجی را بر اساس مورد استفاده خود، از جمله با بازبینی دستی خروجی ها، به طور مناسب ارزیابی کنید.',
    subTitle1: 'ثبت نام و دسترسی',
    subTitle10: 'قابلیت جداسازی',
    subTitle2: 'الزامات استفاده',
    subTitle3: 'محتوا',
    subTitle4: 'هزینه ها و پرداخت',
    subTitle5: 'محرمانه بودن، امنیت و حفاظت از داده ها',
    subTitle6: 'مدت و خاتمه',
    subTitle7: 'غرامت؛ سلب مسئولیت؛ محدودیت مسئولیت',
    subTitle8: 'قانون حاکم و صلاحیت قضایی',
    subTitle9: 'شرایط عمومی',
    title: 'شرایط خدمات',
    updateTime: 'به روز شده: 15 مارس 2024',
  },
  trialModal: {
    btn: 'اکنون شروع کنید (فقط 0.99 دلار)',
    chat: 'چت پی دی اف',
    desc1: 'پس از آزمایش شما، هزینه سالانه 180 دلار از شما دریافت می شود',
    desc2: 'لغو هر زمان',
    focus: 'تمرکز کردن',
    hover: 'ترجمه شناور',
    image: 'ترجمه تصویر',
    installBtn: 'اکنون نصب کنید تا هدیه خود را دریافت کنید',
    memo: 'مدیریت مورد علاقه',
    pdf: 'ترجمه موازی PDF',
    realtime: 'ترجمه فوری',
    select: 'ترجمه انتخاب کلمه',
    title: 'هدیه خوش آمدگویی',
    trialText: 'آزمایشی 7 روزه',
    video: 'ترجمه ویدیویی',
    videoSummary: 'خلاصه ویدیو',
    web: 'ترجمه موازی',
    webSummary: 'خلاصه وب',
  },
  upgradeModal: {
    btn: 'اکنون ارتقا دهید',
    chat: {
      free: 'شما به محدودیت ChatPDF رسیده اید',
      pro: 'به محدودیت ChatPDF برای این ماه رسیده‌اید',
    },
    contactStr: 'لطفاً منتظر تنظیم مجدد بعدی باشید یا با ما در contact@noam.tools تماس بگیرید.',
    limitAlertStr: 'شما به سقف طرح رایگان خود رسیده اید. برای ادامه، ارتقا دهید.',
    more: 'مشاهده پلان ها',
    pageLimit: { free: 'شما به حد مجاز صفحه PDF رسیده اید' },
    title: 'یادآوری',
    upgradeAlertStr: 'شما به سقف طرح رایگان خود رسیده اید. برای ادامه، ارتقا دهید.',
    upload: {
      free: 'شما به حد مجاز ترجمه PDF خود رسیده اید',
      pro: 'شما به حد مجاز ترجمه PDF خود برای این ماه رسیده اید',
    },
  },
  welfare: {
    newUser: {
      joinBtn: 'اکنون بپیوندید',
      label: 'مزایای کاربر جدید:',
      remain: 'فقط 30 تا مونده',
      text: 'فقط 100 نقطه موجود! حالا مال خودت را بگیر!',
    },
  },
}

export default TRANSLATION
